const smartSort = (a: string, b: string): number => a
  .localeCompare(b, undefined, {
    numeric: true,
    sensitivity: 'base',
  });

export default smartSort;
